module.exports = __webpack_public_path__ + "d6ad8148eb9c7807ff3899b388a56f4a.svg";